export class faq {

  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      // Get all FAQ containers using class selector
      const faqContainers = document.getElementsByClassName('faqContainer');
      
      // Convert to array and add event listeners to each container
      Array.from(faqContainers).forEach(container => {
        container.addEventListener('click', (e) => {
          const question = e.target.closest('.faq-question');
          if (question) {
            const faqItem = question.parentElement;
            this.toggleFAQ(faqItem, container);
          }
        });
      });
    });
  }

  toggleFAQ(faqItem, container) {
    const isActive = faqItem.classList.contains('active');
    
    // Close all FAQs only within the current container
    const allFAQs = container.querySelectorAll('.faq-item');
    allFAQs.forEach(item => item.classList.remove('active'));

    // Open clicked FAQ if it wasn't active
    if (!isActive) {
      faqItem.classList.add('active');
    }
  }

}
